import Copy from '@modules/common/icons/copy'
import React, { useState } from 'react'

type Props = {
  displayText: string
  copyText: string
  copyTextClass?: string
  hoverText: string
  hoverTextClass?: string
}

function CopyButton({
  copyText,
  copyTextClass,
  displayText,
  hoverText,
  hoverTextClass,
}: Props) {
  const [hover, setHover] = useState(false)
  const onHover = () => {
    setHover(true)
  }

  const onLeave = () => {
    setHover(false)
  }

  const [notifying, setNotifying] = useState(false)

  function handleCopy() {
    navigator.clipboard.writeText(copyText)
    setNotifying(true)
    setTimeout(() => {
      setNotifying(false)
    }, 1200)
  }

  return (
    <>
      <button
        className="relative"
        onClick={handleCopy}
        onMouseEnter={onHover}
        onMouseLeave={onLeave}
      >
        {displayText}
        {notifying && (
          <span
            className={`absolute top-0 -right-16 p-2 w-[64px] text-xs text-white bg-green-700 rounded-md ${copyTextClass}`}
          >
            Copied!
          </span>
        )}
        <span className="p-3">
          <Copy size={16} className=" inline-block" />
          {hoverText && (
            <sup className={`absolute whitespace-nowrap ${hoverTextClass ? hoverTextClass : ''}`}>
              {hover && !notifying ? hoverText : ''}
            </sup>
          )}
        </span>
      </button>
    </>
  )
}

export default CopyButton
